/**
 * Resolves {variable} placeholders in a URL string.
 *
 * Only the account key is resolved here. Hosts belong in the stored URL, resolved server-side
 * from config.portalurl — the portal bundle inlines process.env at build time and one artifact
 * serves every market, so a host placeholder cannot resolve per-market in the browser.
 *
 * Supported variables:
 *   {partyId}     — the partyId (AccountUID) of the currently selected account. This is the
 *                   key TAP addresses accounts by, so it is what agreement links must use.
 *                   {accountUid} is accepted as an alias — it is the name the field carries
 *                   in gRPC and in TAP's route.
 *   {accountCode} — the accountCode of the currently selected account
 *
 * Usage in CMS / delegateTo field:
 *   https://tap.qa.jti360.co.uk/retailer/accounts/{partyId}/agreements
 */
export function resolveUrlVariables(url, member) {
  if (!url || !url.includes('{')) return url

  const account = member?.accounts?.find(a => a._id === member.selectedAccountId)
  const accountCode = account?.accountCode ?? ''

  // Not every account has a partyId (Bug 21158), and AppUtils.compile leaves the literal
  // placeholder in place for missing fields rather than emitting an empty string. Falling
  // back to accountCode keeps those accounts at the pre-partyId behaviour instead of
  // producing a '{partyId}' or empty path segment.
  const rawPartyId = account?.partyId
  const partyId = !rawPartyId || rawPartyId === '{partyId}' ? accountCode : rawPartyId

  return url
    .replace(/\{partyId\}/g, partyId)
    .replace(/\{accountUid\}/g, partyId)
    .replace(/\{accountCode\}/g, accountCode)
}
